import React from 'react';
import { Box, Button, Divider, Stack, Typography, Chip } from '@mui/material';
import QuizOutlinedIcon from '@mui/icons-material/QuizOutlined';

/**
 * PosteQuizView
 * Shows the main poste-linked quiz card with metadata and Start button.
 */
const PosteQuizView = ({
  quizMeta,
  total,
  hasInProgress,
  attemptsUsedApi,
  onStart,
  starting,
  resolvedQuizId
}) => {
  return (
    <Box sx={{ maxWidth: 520, width: '100%', mx: 'auto', p: 3, borderRadius: 2, boxShadow: 3, border: '1px solid rgba(0,0,0,0.06)', textAlign: 'center' }}>
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
        <QuizOutlinedIcon color="primary" fontSize="large" />
      </Box>
      <Typography variant="h6" sx={{ mb: 1 }}>{quizMeta.title}</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        This quiz evaluates your skills for the position {quizMeta.posteName || '-' }.
      </Typography>
      <Divider sx={{ my: 1.5 }} />
      <Stack spacing={1.2} sx={{ textAlign: 'left' }}>
        <Typography variant="body2"><strong>Questions:</strong> {quizMeta.questionsCount || total}</Typography>
        <Typography variant="body2"><strong>Time:</strong> {quizMeta.timeLimitMin} min</Typography>
        <Typography variant="body2"><strong>Attempts allowed:</strong> {quizMeta.maxAttempts || 1}</Typography>
      </Stack>
      <Divider sx={{ my: 2 }} />
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Click Start when you are ready. The timer will begin immediately.
      </Typography>
      <Button size="large" variant="contained" onClick={onStart} disabled={
        starting || !Number.isFinite(resolvedQuizId) || resolvedQuizId <= 0 || (!hasInProgress && (Number(quizMeta.maxAttempts||1) <= attemptsUsedApi))
      }>
        Start Quiz
      </Button>
      {Number(quizMeta.maxAttempts||1) <= attemptsUsedApi && (
        <Typography variant="caption" color="error" sx={{ display: 'block', mt: 1 }}>
          {hasInProgress ? 'You have an attempt in progress. You can continue it.' : 'You have reached the maximum number of attempts.'}
        </Typography>
      )}
    </Box>
  );
};

export default PosteQuizView;
